import React from "react";
export function Nav() {
  return <header className="fixed inset-x-0 top-0 z-50 border-b border-line bg-ink/95 backdrop-blur-md" data-id="element-79" data-mp="27lxkintwiokf">
      <nav className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6" aria-label="Principal" data-id="element-80" data-mp="120fw6m8dwqc2">
        <a href="#inicio" className="font-serif text-base font-bold text-accent" data-id="element-81" data-mp="171deqzxb3me3">
          Marcos Rosell
        </a>
        <a href="#unirme" className="rounded-lg bg-accent px-4 py-3 text-sm font-bold text-black transition-colors duration-150 hover:bg-accent-hover" data-id="element-82" data-mp="1fzytsl3kkja4">
          Unirme
        </a>
      </nav>
    </header>;
}